import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../utils/api';

// Query Keys
export const chargingHistoryQueryKeys = {
  all: ['chargingHistories'],
  lists: (params) => [...chargingHistoryQueryKeys.all, 'list', params],
  list: (params) => [...chargingHistoryQueryKeys.lists(params)],
  timeSlots: () => [...chargingHistoryQueryKeys.all, 'timeSlot'],
  timeSlot: (id) => [...chargingHistoryQueryKeys.timeSlots(), id],
};

// 충전 이력 목록 조회
export const useChargingHistories = (params = {}) => {
  return useQuery({
    queryKey: chargingHistoryQueryKeys.list(params),
    queryFn: async () => {
      const response = await api.get('/drivecore/stat/api/ChargingHistory', { params });
      return response || null;
    },
    staleTime: 5 * 60 * 1000,
  });
};


// 충전 이력 time slot 조회
export const useChargingHistoryTimeSlot = (id, targetDayStr) => {
  return useQuery({
    queryKey: chargingHistoryQueryKeys.timeSlot(id),
    queryFn: async () => {
      const response = await api.get(`/drivecore/stat/api/ChargingHistory/TimeSlotStat/${id}?targetDayStr=${targetDayStr}`);
      return response || null;
    },
    enabled: !!id && !!targetDayStr,
  });
};